import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PageLoader from "./pageLoader";

export const Redirect = ({ route }: { route: any }) => {
  let navigate = useNavigate();
  useEffect(() => {
    if (!route.to) {
      navigate("/");
      return;
    }
    navigate(route?.to);
  }, [navigate, route.to]);
  return <PageLoader />;
};
